angular.module('shared').factory('TestEmailsService', ["$modal", "$filter", function($modal, $filter) {
  return {
    sendTestEmail: function(params) {
      var modalInstance;
      modalInstance = $modal.open({
        template: require('templates/shared/send_test_email_modal.html.slim'),
        size: 'lg',
        controller: ["$scope", "$rootScope", "$http", "$modalInstance", "flash", function($scope, $rootScope, $http, $modalInstance, flash) {
          $scope.params = params;
          if (params.contact) {
            $scope.selectedContacts = [params.contact];
            $scope.params.contact_id = params.contact.id;
          }
          $scope.onSelect = function(contact) {
            return $scope.params.contact_id = contact.id;
          };
          $scope.onRemove = function() {
            return $scope.params.contact_id = void 0;
          };
          $scope.submit = function() {
            var headTagContent, messageParams, url;
            if (!$scope.params.contact_id) {
              $scope.errors = {
                contact: ['This field is required']
              };
              return;
            }
            $scope.isLoading = true;
            url = `/gyms/${params.gymId || $rootScope.gym.id}/test_comms/send_email`;
            headTagContent = $rootScope.gym.gym_config.can_set_email_template_head_tag ? $scope.params.head_tag_content : void 0;
            messageParams = {
              contact_id: $scope.params.contact_id,
              content: $filter('domPurify')($scope.params.content),
              reply_address: $scope.params.reply_address,
              subject: $filter('sanitizeEditorField')($scope.params.subject, true, {
                target: 'subject'
              }),
              head_tag_content: headTagContent
            };
            return $http.post(url, {
              message: messageParams
            }).then(function() {
              $modalInstance.close();
              return flash.success = `Test email sent to: ${params.reply_address}`;
            }, function() {
              return $scope.isLoading = false;
            });
          };
          return $scope.cancel = function() {
            return $modalInstance.dismiss('cancel');
          };
        }]
      });
      return modalInstance.result;
    }
  };
}]);
